import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressBar } from '@angular/material/progress-bar'
import { SupplierPortalQuoteService } from '../../../core/services/supplier-portal/supplier-portal-quote.service'
import { ResponseRequestModel } from '../../../core/models/response.model'
import { FornecedorCotacaoItinerarioPontoVm } from '../../../core/models/supplier-portal.model'

// Itinerários do trecho, abertos a partir do modal de precificação. Mesmo formato do modal do
// operador, mas alimentado pela rota do portal (FornecedorPortalCotacao/{id}/itinerario), que
// valida a posse do item antes de devolver os pontos.
@Component({
  selector: 'modal-supplier-portal-quote-itinerary',
  standalone: true,
  imports: [MatCard, MatCardHeader, MatCardTitle, MatIconModule, MatProgressBar],
  templateUrl: './modal-supplier-portal-quote-itinerary.component.html',
  styleUrl: './modal-supplier-portal-quote-itinerary.component.scss',
})
export class ModalSupplierPortalQuoteItineraryComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ModalSupplierPortalQuoteItineraryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { itemCotacaoId: string },
    private supplierPortalQuoteService: SupplierPortalQuoteService,
  ) {}

  loading = false
  pontos: FornecedorCotacaoItinerarioPontoVm[] = []

  ngOnInit(): void {
    this.getItinerario()
  }

  close() {
    this.dialogRef.close()
  }

  // Achata { origem, paradas[], destino } na ordem do trajeto, como o modal do operador.
  getItinerario() {
    this.loading = true
    this.pontos = []
    this.supplierPortalQuoteService.getItinerario(this.data.itemCotacaoId).subscribe({
      next: (response: ResponseRequestModel) => {
        const dados = response?.data
        const pontos: FornecedorCotacaoItinerarioPontoVm[] = []
        if (dados?.origem?.id) {
          pontos.push(dados.origem)
        }
        for (const parada of dados?.paradas ?? []) {
          pontos.push(parada)
        }
        if (dados?.destino?.id) {
          pontos.push(dados.destino)
        }
        this.pontos = pontos
      },
      error: () => {
        this.pontos = []
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  tituloPonto(ponto: FornecedorCotacaoItinerarioPontoVm): string {
    if (ponto.trecho == 'O') return 'Origem'
    if (ponto.trecho == 'D') return 'Destino'
    return 'Parada'
  }

  temEndereco(ponto: FornecedorCotacaoItinerarioPontoVm): boolean {
    return !!(
      ponto.cep ||
      ponto.logradouro ||
      ponto.numero ||
      ponto.bairro ||
      ponto.complemento ||
      ponto.horaParada ||
      ponto.tempoPermanencia ||
      ponto.atividades
    )
  }
}
